/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Intro_P3Inputs */

const es_privacy_policy_intro_p3 = /** @type {(inputs: Privacy_Policy_Intro_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al utilizar Nexata, usted reconoce que ha leido, comprendido y acepta los terminos de esta Politica de Privacidad.`)
};

const en_privacy_policy_intro_p3 = /** @type {(inputs: Privacy_Policy_Intro_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By using Nexata, you acknowledge that you have read, understood, and agree to the terms of this Privacy Policy.`)
};

/**
* | output |
* | --- |
* | "By using Nexata, you acknowledge that you have read, understood, and agree to the terms of this Privacy Policy." |
*
* @param {Privacy_Policy_Intro_P3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_intro_p3 = /** @type {((inputs?: Privacy_Policy_Intro_P3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Intro_P3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_intro_p3(inputs)
	return en_privacy_policy_intro_p3(inputs)
});
export { privacy_policy_intro_p3 as "privacy_policy.intro.p3" }